import { SidebarItemDescription } from './common-sidebar-section.types';
import { StyledSidebarItem } from './sidebar-section-base-item';
import { StyledSidebarButton } from './styled-sidebar-button';

export const SidebarSectionButton = (
  props: SidebarItemDescription &
    React.ButtonHTMLAttributes<HTMLButtonElement> & { isSidebarOpen: boolean }
) => {
  return (
    <StyledSidebarButton onClick={props.onClick}>
      <StyledSidebarItem
        icon={props.icon}
        label={props.label}
        isSidebarOpen={props.isSidebarOpen}
        notificationCount={props.notificationCount}
      />
    </StyledSidebarButton>
  );
};
